export const state = () => ({
  currentQuestion: {},
  nextQuestion: {},
  statusProcess: '',
  totalQuestions: 0,
  currentQuestionIndex: 1,
  prevQuestion: null,
})

export const actions = {
  async getCurrentQuestion({ commit }, { _id }) {
    const { data } = await this.$axios.get(`question/${_id}`)
    commit('setCurrentQuestion', data.question)
    commit('setCurrentQuestionIndex', data.currentQuestionIndex)
    commit('setTotalQuestions', data.quantityQuestions)
    commit('setPrevQuestion', data.prevQuestion)
  },
  async answerQuestion({ commit }, params) {
    const { data } = await this.$axios.put('coaching/answerCoaching', params)
    commit('setNextQuestion', data)
  },
}

export const mutations = {
  setCurrentQuestionIndex(state, data) {
    state.currentQuestionIndex = data
  },
  setCurrentQuestion(state, data) {
    state.currentQuestion = data
  },
  setTotalQuestions(state, data) {
    state.totalQuestions = data
  },
  setPrevQuestion(state, data) {
    state.prevQuestion = data
  },
  setNextQuestion(state, data) {
    state.nextQuestion = data.nextQuestion
    state.statusProcess = data.statusProcess
  },
}
